<template>
	<div>
		<el-upload
			:accept="
				accept == 'mp4'
					? '.mp4, .avi, .wmv, .MP4, .AVI, .WMV, .swf, .mpeg, .mpg, .flv, .m3u8'
					: accept == 'img'
						? '.jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF'
						: accept == 'doc'
							? '.pdf, .doc, .docx, .xls, .xlsx'
							: `${accept}`
			"
			:before-upload="uploadBefore"
			:file-list="fileList"
			:limit="1"
			:on-remove="onRemove"
			action
			drag>
			<template v-if="fileList.length == 0">
				<i class="el-icon-upload"></i>
				<div class="upload-import-text-main">
					<span>点击上传或拖拽文件到这里进行上传</span>
				</div>
			</template>
			<template v-else>
				<div v-if="accept == 'doc'" style="display: flex; align-items: center; justify-content: center; height: 100%">
					文档(暂无法预览)
				</div>
				<el-image
					v-if="accept == 'img'"
					:src="formData[prop]"
					style="width: 100%; height: 100%; cursor: pointer"></el-image>
				<video
					v-if="accept == 'mp4'"
					:src="formData[prop]"
					style="width: 100%; height: 100%; cursor: pointer"
					@click.stop="previewFlag = accept == 'mp4'"></video>
			</template>
		</el-upload>

		<el-dialog :append-to-body="true" :modal="false" :visible.sync="previewFlag" title="预览视频" width="50vw">
			<video :src="formData[prop]" controls style="width: 100%; height: 50vh"></video>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="previewFlag = false">确 认</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import {uploadOSSCustom} from '@/util/upload.js'

export default {
	name: 'ossUpload',
	props: {
		// 配置信息
		prop: {
			type: String,
			default: 'url',
		},
		ossParam: {
			//阿里云 oss 上传参数
			default: () => {
				return {
					acl: 1,
				}
			},
		},
		formData: {
			default: {},
		},
		accept: {
			type: String,
			default: 'mp4',
		},
		isNeedTime: {
			//是否需要视频时长
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			previewFlag: false,
			fileList: [],
			file: {},
		}
	},

	created() {
		if (this.formData[this.prop]) {
			this.fileList = [{name: this.formData[this.prop].split('?')[0], url: this.formData[this.prop]}]
			if (this.formData[this.prop] && this.accept == 'mp4' && this.isNeedTime) {
				const audioElement = new Audio(this.formData[this.prop]) //audio也可获取视频的时长
				audioElement.addEventListener('loadedmetadata', (_event) => {
					if (audioElement.duration) {
						this.formData.time = Math.floor(audioElement.duration)
					}
				})
			}
		}
	},

	methods: {
		async uploadBefore(file) {
			this.file = file
			const url = URL.createObjectURL(file) //获取录音时长
			if (this.accept == 'mp4' && this.isNeedTime) {
				const audioElement = new Audio(url) //audio也可获取视频的时长
				audioElement.addEventListener('loadedmetadata', (_event) => {
					if (audioElement.duration) {
						this.formData.time = Math.floor(audioElement.duration)
					}
				})
			}

			//生成本地预览的url
			this.formData[this.prop] = url
			setTimeout(() => {
				this.fileList = [{name: file.name, url}]
			}, 50)

			loading()
		},
		onRemove(e) {
			if (e.status == 'success') {
				this.formData[this.prop] = ''
			}
			this.fileList = []
		},
		//提交上传文件
		async submitFile() {
			let row = await uploadOSSCustom(this.file, this.ossParam)
			return row
		},
	},
}
</script>

<style lang="scss" scoped></style>
